import React from "react";
import FadeIn from "react-fade-in";

// COMPONENTS
import bcaaImg from "assets/bcaa.png";
import suppsImg from "assets/supps.svg";
import creatineImg from "assets/creatine.png";
import glutamineImg from "assets/glutamine.svg";
import betaAlanineImg from "assets/beta-alanine.png";
import Title from "components/layout/Title";
import Nav from "components/Nav";
import AnchorLink from "react-anchor-link-smooth-scroll";

import SubNavLink from "../components/SubNavLink";
import Item from "../components/Item";

import {
    colorCreatine,
    colorBetaAlanine,
    colorBcaa,
    colorGlutamine,
} from "sass/partials/_variables.scss";

const Supps = () => {
    return (
        <FadeIn>
            <Nav supps={true} />
            <main>
                <article className="page">
                    <Title
                        bg={suppsImg}
                        bgSize="100%"
                        bgRepeat="no-repeat"
                        bgPos="center 30%"
                    >
                        Supplements
                    </Title>
                    <div>
                        <h2 className="introtext">So you might ask:</h2>
                        <h3 className="introtext">Do we even need them?</h3>
                        <h4 className="introtext">
                            For vegetarians, especially those who work out,
                            taking that extra step to make sure you're adding
                            essential amino acids to your diet is paramount.
                            After all, cutting meat from your diet comes at a
                            cost, but that doesn't have to be your gains. Check
                            out this list of pre- and post-workout supplements
                            to help you fuel your workouts and reach your full
                            fitness potential.
                            <sup>
                                <AnchorLink
                                    href="https://www.bodybuilding.com/content/5-key-supplements-for-vegetarians.html"
                                    title="content from livestrong.com"
                                >
                                    1
                                </AnchorLink>
                            </sup>
                        </h4>
                        <nav className="subnav subnav-list supps">
                            <SubNavLink
                                text="Creatine"
                                shortName="creatine"
                                color={colorCreatine}
                            />
                            <SubNavLink
                                text="Beta-Alanine"
                                shortName="beta-alanine"
                                color={colorBetaAlanine}
                            />
                            <SubNavLink
                                text="BCAA"
                                shortName="bcaa"
                                color={colorBcaa}
                            />
                            <SubNavLink
                                text="Glutamine"
                                shortName="glutamine"
                                color={colorGlutamine}
                            />
                        </nav>
                    </div>
                    <Item
                        title="Creatine Monohydrate"
                        subtitle="only get through diet"
                        shortName="creatine"
                        color={colorCreatine}
                        img={creatineImg}
                        data={[
                            { name: "Good for", stat: "storing energy" },
                            { name: "Daily dose", stat: "5 g" },
                        ]}
                    />
                    <Item
                        title="Beta-Alanine"
                        subtitle="produced in muscle tissue"
                        shortName="beta-alanine"
                        color={colorBetaAlanine}
                        img={betaAlanineImg}
                        data={[
                            { name: "Good for", stat: "delaying fatigue" },
                            { name: "Daily dose", stat: "3 - 6 g" },
                        ]}
                    />
                    <Item
                        title="BCAAs"
                        subtitle="Drink before, during, and after workouts"
                        shortName="bcaa"
                        color={colorBcaa}
                        img={bcaaImg}
                        data={[
                            {
                                name: "Good for",
                                stat: "suppress protein degradation",
                            },
                            { name: "Daily dose", stat: "10 - 15 g" },
                        ]}
                    />
                    <Item
                        title="Glutamine"
                        subtitle="Drink 10g before, and 10g after workouts"
                        shortName="glutamine"
                        color={colorGlutamine}
                        img={glutamineImg}
                        data={[
                            {
                                name: "Good for",
                                stat:
                                    "Supports immune system, regulate acid-base balance",
                            },
                            { name: "Daily dose", stat: "20 g" },
                        ]}
                    />
                </article>
            </main>
        </FadeIn>
    );
};

export default Supps;
